import { Card, CardContent } from '@repo/ui/src/components/ui/card';

/** The spinner both settings sections that mount from `useOrgSettings` show
 *  while the org settings load — their forms take their initial values as
 *  props, so they must not mount before those values exist. */
export function SectionLoading() {
  return (
    <Card>
      <CardContent className="py-12">
        <div className="flex justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-500 border-t-transparent" />
        </div>
      </CardContent>
    </Card>
  );
}
